import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { banco } from '../../db/banco'
import { novoRegistroBase } from '../../db/tipos'
import { gravarEmLote } from '../../sync/outbox'
import { podeSair } from '../../componentes/guardaDeSaida'
import { gravacoesDeTabelaNova } from '../../precos/tabelaNova'

// "+ Tabela" (spec 2026-09-29, secao 4): importar a planilha, como sempre, ou
// criar do zero com nome e % de comissao. Mesmo visual da JanelaConfirmacao.
export default function JanelaNovaTabela({ representadaId, aoFechar }: { representadaId: string; aoFechar: () => void }) {
  const navegar = useNavigate()
  const [passo, setPasso] = useState<'escolha' | 'zero'>('escolha')
  const [nome, setNome] = useState('')
  const [pct, setPct] = useState('')
  const [erros, setErros] = useState<{ erroNome?: string; erroPct?: string }>({})
  const [enviando, setEnviando] = useState(false)

  async function sair(destino: string) {
    // a aba pode estar em edicao: mesma pergunta de descartar de sempre
    if (!(await podeSair())) return
    aoFechar()
    navegar(destino)
  }

  async function criar() {
    if (enviando) return
    setEnviando(true)
    try {
      const tabelasVivas = await banco.tabelas_preco.where('representada_id').equals(representadaId).filter((t) => t.apagado_em === null).toArray()
      const regraDaFornecedora = await banco.regras_comissao.where('representada_id').equals(representadaId)
        .filter((r) => r.apagado_em === null && r.tabela_preco_id === null).first()
      const r = gravacoesDeTabelaNova({ representadaId, nome, pct, tabelasVivas, regraDaFornecedora, novo: novoRegistroBase })
      if (!('gravacoes' in r)) { setErros(r); return }
      if (!(await podeSair())) return
      await gravarEmLote(r.gravacoes)
      aoFechar()
      navegar(`/tabelas/${r.tabelaId}?filtro=fora`)
    } finally {
      setEnviando(false)
    }
  }

  const campo = 'w-full border border-slate-300 rounded-lg px-3 py-2 text-sm'
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end" onClick={aoFechar}>
      <div role="dialog" aria-modal="true" aria-label="Nova tabela"
        className="w-full bg-white rounded-t-2xl p-4 pb-6 space-y-4" onClick={(e) => e.stopPropagation()}>
        <p className="text-base font-semibold text-slate-800">Nova tabela de preço</p>
        {passo === 'escolha' ? (
          <div className="grid grid-cols-2 gap-3">
            <button type="button" onClick={() => void sair(`/importar?tipo=produtos&representada=${representadaId}`)}
              className="rounded-lg border border-slate-300 py-3 font-semibold text-slate-700">Importar planilha</button>
            <button type="button" onClick={() => setPasso('zero')}
              className="rounded-lg bg-teal-700 py-3 font-semibold text-white">Criar do zero</button>
          </div>
        ) : (
          <div className="space-y-3">
            <label className="block text-xs text-slate-600">Nome
              <input value={nome} onChange={(e) => setNome(e.target.value)} className={campo} />
              {erros.erroNome && <span className="block text-xs text-red-700 mt-0.5">{erros.erroNome}</span>}
            </label>
            <label className="block text-xs text-slate-600">% de comissão
              <input value={pct} onChange={(e) => setPct(e.target.value)} inputMode="decimal" placeholder="ex.: 1,5" className={campo} />
              {erros.erroPct && <span className="block text-xs text-red-700 mt-0.5">{erros.erroPct}</span>}
            </label>
            <div className="grid grid-cols-2 gap-3">
              <button type="button" onClick={aoFechar} className="rounded-lg border border-slate-300 py-3 font-semibold text-slate-700">Cancelar</button>
              <button type="button" disabled={enviando} onClick={() => void criar()}
                className="rounded-lg bg-teal-700 py-3 font-semibold text-white disabled:opacity-60">Criar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
